module.exports = "/images/milano-6.jpg";